import { Customer } from "@/services/api";
import * as React from "react";

export interface ISuperUserContext {
	hasSuperUserRole?: boolean;
	isSuperUser?: boolean;
	impersonatedUserId?: string | null;
	setSuperUser: (value: boolean) => void;
	setImpersonatedUser: (impersonatedUserId?: string | null) => void;
}
export const SuperUserContext = React.createContext<ISuperUserContext>({
	setSuperUser: () => {},
	setImpersonatedUser: () => {},
});

export function useSuperUserContext() {
	return React.useContext(SuperUserContext);
}
